import { useEffect } from 'react'
import { BROWSER_AUTORELOAD } from 'constants/appConstants'

const AutoReload = () => {
  useEffect(() => {
    const reloadInterval = setInterval(() => {
      window.location.reload()
    }, BROWSER_AUTORELOAD)

    return () => clearInterval(reloadInterval)
  }, [])

  return null
}

export default AutoReload
